import * as React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import {
    ApiBookingsCsv,
    ApiBookingsList,
    ApiCourseProvidersAutoSuggest,
    BookingListLine,
    BookingsListParams,
    CourseProviderAutoSuggestListResult,
    CourseProvidersAutoSuggestResult,
    ServerResponse,
} from '../../api';
import DateRangeInput from '../../components/dateRangeInput/DateRangeInput';
import Footer from '../../components/footer/Footer';
import HeaderLoggedIn from '../../components/headerLoggedIn/HeaderLoggedIn';
import LiveSearchInput from '../../components/liveSearchInput/LiveSearchInput';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import Paging from '../../components/paging/Paging';
import { IThConfig } from '../../components/sortableTh/SortableTh';
import TableBoxWithCollapseIcon from '../../components/tableBoxWithCollapseIcon/TableBoxWithCollapseIcon';
import { IEmptyProps, ISortIcon } from '../../constants';
import './AdminAllBooking.css';

interface IState {
    listData: BookingListLine[];
    loading: boolean;
    serverResponse?: ServerResponse;
    searchParams: BookingsListParams;
    totalCount: number;
    sortIcon: ISortIcon[];
}

export default class AdminAllBooking extends React.PureComponent<IEmptyProps, IState> {
    private renderTHeadLineArrays: IThConfig[] = [
        { name: '', width: '2%' },
        { sortField: 'CourseProviderName', name: 'Kursanbieter', width: '15%' },
        { sortField: 'CourseName', name: 'Kursname', width: '19%' },
        { sortField: 'lecturer', name: 'Dozent', width: '10%' },
        { sortField: 'insertDate', name: 'Buchungdatum', width: '9%' },
        { sortField: 'appointment', name: 'Kursdatum', width: '9%' },
        { sortField: 'LastName', name: 'Teilnehmer', width: '10%' },
        { sortField: 'bookingOptionPrice', name: 'Gebühr', width: '7%' },
        { sortField: 'commissionFee', name: 'Provision', width: '9%' },
        { sortField: 'bookingOptionName', name: 'Buchungsop.', width: '10%' },
    ];

    constructor(props: IEmptyProps) {
        super(props);
        const l = window.location.href;
        let search = '';
        if (l.indexOf('?search=') > -1) {
            search = decodeURIComponent(l.substr(l.lastIndexOf('?search=') + 8));
        }
        this.state = {
            listData: [],
            loading: true,
            searchParams: {
                CourseProviderId: '',
                Descending: true,
                EndDate: '',
                Offset: 0,
                PageSize: 50,
                Search: search,
                Sort: 'insertDate',
                StartDate: '',
            },
            serverResponse: undefined,
            sortIcon: [],
            totalCount: 0,
        };
    }

    public componentDidMount() {
        const mySortIcon = this.state.sortIcon;
        this.renderTHeadLineArrays.map(() => {
            mySortIcon.push(0);
        });
        this.setState({ sortIcon: [...mySortIcon] });
        this.searchBookings();
    }

    public render() {
        return (
            <NetworkOverlay loading={this.state.loading}>
                <HeaderLoggedIn />
                <Container>
                    <Row>
                        <Col className={'searchLine'}>
                            <LiveSearchInput
                                placeholder={TR.adminAllBooking_search_course_provider}
                                onFetchRequest={(search, callback) => {
                                    ApiCourseProvidersAutoSuggest(
                                        {
                                            Search: search,
                                        },
                                        (sr: ServerResponse & { Data: CourseProviderAutoSuggestListResult }) => {
                                            if (sr.OK) {
                                                callback(sr.Data.CourseProviders);
                                            } else {
                                                callback([]);
                                            }
                                        }
                                    );
                                }}
                                onClear={() => {
                                    this.changeValue('CourseProviderId', '', true, true);
                                }}
                                renderSuggestion={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    return <span>{suggestion.Name}</span>;
                                }}
                                getSuggestionValue={(suggestion: CourseProvidersAutoSuggestResult) => {
                                    this.changeValue('CourseProviderId', suggestion.ID, true, true);
                                    return suggestion.Name;
                                }}
                            />
                            <div>
                                <input
                                    name="CourseNameSearching"
                                    type="text"
                                    placeholder={TR.adminAllBooking_search}
                                    value={this.state.searchParams.Search}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        this.changeValue('Search', e.target.value, true, true);
                                    }}
                                />
                            </div>
                            <DateRangeInput
                                onChangeOptionFrom={(value: string) => {
                                    this.changeValue('StartDate', value, true, true);
                                }}
                                onChangeOptionTo={(value: string) => {
                                    this.changeValue('EndDate', value, true, true);
                                }}
                            />
                            <div className={'text-right'}>
                                <Button size="sm" color="danger" onClick={ApiBookingsCsv}>
                                    <span>CSV Export</span>
                                </Button>
                            </div>
                        </Col>
                    </Row>
                    {!this.state.loading && (
                        <Row className="mt-5">
                            <Col>
                                <TableBoxWithCollapseIcon
                                    listData={this.state.listData}
                                    renderTHeadLine={this.renderTHeadLineArrays}
                                    onClickSorting={this.onClickSorting}
                                    sortIcon={this.state.sortIcon}
                                />
                                <Paging
                                    totalCount={this.state.totalCount}
                                    pageSize={this.state.searchParams.PageSize}
                                    offset={this.state.searchParams.Offset}
                                    changeValue={this.changeValue}
                                />
                            </Col>
                        </Row>
                    )}
                </Container>
                <Footer />
            </NetworkOverlay>
        );
    }

    private changeValue = (
        fieldName: string,
        value: string | boolean | number,
        reload: boolean = false,
        resetPaging: boolean = false
    ) => {
        const newParams = { ...this.state.searchParams };
        // @ts-ignore
        newParams[fieldName] = value;
        if (resetPaging) {
            newParams.Offset = 0;
        }
        if (reload) {
            this.setState({ searchParams: newParams }, this.searchBookings);
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private searchBookings = () => {
        ApiBookingsList({ ...this.state.searchParams }, (sr) => {
            if (sr.OK) {
                this.setState({
                    listData: sr.Data ? sr.Data.Lines : [],
                    loading: false,
                    serverResponse: sr,
                    totalCount: sr.Data ? sr.Data.Count : 0,
                });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };

    private onClickSorting = (sortField: string, index: number, sortIcon: ISortIcon) => {
        this.changeValue('Sort', sortField, true);
        const mySortIcon: ISortIcon[] = [];
        this.state.sortIcon.map(() => mySortIcon.push(ISortIcon.Sort));
        mySortIcon[index] = sortIcon;
        if (sortIcon === ISortIcon.Sort) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
        if (sortIcon === ISortIcon.SortUp) {
            mySortIcon[index] = ISortIcon.SortDown;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', true, true);
            });
        }
        if (sortIcon === ISortIcon.SortDown) {
            mySortIcon[index] = ISortIcon.SortUp;
            this.setState({ sortIcon: [...mySortIcon] }, () => {
                this.changeValue('Sort', sortField, true);
                this.changeValue('Descending', false, true);
            });
        }
    };
}



// WEBPACK FOOTER //
// ./src/views/adminAllBooking/AdminAllBooking.tsx